import { render } from "./PeraturanView.vue?vue&type=template&id=307515b0&ts=true"
import script from "./PeraturanView.vue?vue&type=script&lang=ts"
export * from "./PeraturanView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__